'use strict';

/*global app*/
/*global services*/
/*global Promise*/
/*global resError*/
/*global invokeCallback*/
/*global blockElement*/
/*global unBlockElement*/

function Production(containerId) {
  this.containerId = containerId;
  this.$container = null;
  this.$form = null;

  this.init();
}

Production.prototype = $.extend({}, {
  constructor: 'Production',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    _this.$form.on('change', '.production-form__input', function () {
      _this.onChangeInput($(this));
    });

    _this.$form.on('keypress', '.production-form__input', function (e) {
      var c = e.which ? e.which : e.keyCode;
      if (c === 13) {
        e.preventDefault();
        _this.onChangeInput($(this));
      }
    });

    _this.$form.on('submit', function () {
      blockElement(_this.$form);
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  findLocation: function (name, value, callback) {
    var _this = this;

    var warehouseId = _this.$form.find('[name$="[WarehouseId]"]').val();
    services.get('barcode-service').findLocation(value, warehouseId, function (res, resData) {
      if (res === resError) {
        app.viewErrorMessage('Nepodařilo se dohledat umístění', function () {
          invokeCallback(callback, false);
        });
      }

      _this.$form.find('[name="' + name + '"]').val(resData.Id);

      invokeCallback(callback, true);
    });

    return _this;
  },

  findArticle: function (name, value, callback) {
    var _this = this;

    services.get('barcode-service').findArticle(value, 0, function (res, resData) {
      if (res === resError) {
        app.viewErrorMessage('Nepodařilo se dohledat zbozi', function () {
          invokeCallback(callback, false);
        });
      }

      _this.$form.find('[name="' + name + '"]').val(resData.Id);

      var $measureUnit = _this.$form.find('[name$="[ArticleMeasureUnit]"]');
      $measureUnit.val(resData.Unit);

      var $quantity = _this.$form.find('[name$="[Quantity]"]');
      $quantity.parent().find('.value-suffix').text(resData.Unit);
      $quantity.attr('data-value_suffix', resData.Unit);
      $quantity.data('value_suffix', resData.Unit);
      $quantity.data('keyboard').suffix = resData.Unit;

      invokeCallback(callback, true);
    });

    return _this;
  },

  doActionByInput: function ($input) {
    var _this = this;

    var field = $input.data('field');
    var name = $input.attr('name').replace('Abbr', 'Id');
    var value = $input.val();

    return new Promise(function (resolve, reject) {
      switch (field) {
        case 'location' : {
          _this.findLocation(name, value, function (res) {
            if (res) {
              resolve();
            } else {
              reject();
            }
          });
        }

        break;
        case 'article' : {
          _this.findArticle(name, value, function (res) {
            if (res) {
              resolve();
            } else {
              reject();
            }
          });
        }

        break;
        case 'quantity' : {
          resolve();
        }

        break;
        default : reject();
      }
    });
  },

  onChangeInput: function ($input) {
    var _this = this;

    //zkontrolujeme a aktualizujeme posledni hodnotu
    var lastValue = $input.data('last_value');
    $input.data('last_value', $input.val());
    if ($input.val() === lastValue) {
      return;
    }

    if (!$input.val()) {
      return;
    }

    var promise = Promise.resolve();

    //zablokujeme formular
    promise = promise.then(function () {
      return new Promise(function (resolve) {
        blockElement(_this.$form);
        resolve();
      });
    });

    //provedeme akci dle inputu
    promise = promise.then(function () {
      return _this.doActionByInput($input);
    });

    //nakonec provedeme focus na input
    promise = promise.then(function () {
      var $inputs = _this.$form.find('.production-form__input');

      var index = $inputs.index($input);
      var $nextInput = index + 1 < $inputs.length ? $inputs.eq(index + 1) : null;

      //musim tady, nemohu pouzit finally, protoze pak posilam form, ktery chci take blokovat
      unBlockElement(_this.$form);

      //pokud mam dalsi pole, tak focus, jinak submit formu
      if ($nextInput) {
        $nextInput.focus();
      } else {
        _this.$form.submit();
      }
    });

    //pokud se neco nepovedlo, tak se vracim
    promise = promise.catch(function () {
      unBlockElement(_this.$form);

      $input.val('');
      $input.focus();
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.$container = $('#' + this.containerId);
    _this.$form = _this.$container.find('form');

    //zafokusujeme prvni input
    var $input = _this.$form.find('.production-form__input:first');
    $input.focus();

    _this.registerCallbacks();

    return _this;
  }
});
